import type { CSSProperties } from "react";
import { commonEmployerCountries, employerCountryOptions } from "./employer-crm";

/**
 * Country picker for an employer, stored the same "Name (code)" way as the
 * employer page's Location field. The usual four sit at the top.
 */
export function EmployerCountrySelect({
  id,
  value,
  onChange,
  required,
  className,
  style,
}: {
  id: string;
  value?: string;
  onChange?: (v: string) => void;
  required?: boolean;
  className?: string;
  style?: CSSProperties;
}) {
  const rest = employerCountryOptions.filter((c) => !commonEmployerCountries.includes(c));
  return (
    <select
      id={id}
      required={required}
      {...(onChange ? { value: value ?? "", onChange: (e) => onChange(e.target.value) } : { defaultValue: "" })}
      className={className}
      style={style}
    >
      <option value="">Choose a country</option>
      <optgroup label="Most common">
        {commonEmployerCountries.map((c) => (
          <option key={c} value={c}>
            {c.replace(/ \([A-Z]{2}\)$/, "")}
          </option>
        ))}
      </optgroup>
      <optgroup label="All countries">
        {rest.map((c) => (
          <option key={c} value={c}>
            {c.replace(/ \([A-Z]{2}\)$/, "")}
          </option>
        ))}
      </optgroup>
    </select>
  );
}
